<template>
  <div class="room-doc-share-component" data-grm-comp="Share">
    <div class="room-doc-share">
      <div v-if="me.roomUserRole.draw"
           class="room-doc-share-start"
           :class="{ isOpen: isOpenDocFileList }"
      >
        <div class="room-doc-share-list-wrapper" :class="{ page: isShowDocPage }">
          <div class="room-doc-share-list-container">
            <div class="room-doc-share-start-header">
              <div class="room-doc-share-start-header-title-wrapper">
                <p class="room-doc-share-start-header-title">{{ $t("doc.share.title") }}</p>
              </div>
            </div>
            <perfect-scrollbar class="min-h-0 flex-1">
              <div class="room-doc-share-start-body">
                  <div class="room-doc-share-file-list-wrapper">
                    <RoomDocList @onToggleShowDocPage="onToggleShowDocPage" @setShowDocPage="setShowDocPage" />
                    <ul class="room-doc-share-file-list">
                      <li class="room-doc-share-file-item add file" @click="handleClickAddDoc">
                        <div class="room-doc-share-file">
                          <label for="file" class="room-doc-share-add-label">
                            <input type="file" id="file" class="room-doc-share-add-input" />{{ $t("doc.share.add.file") }}</label>
                        </div>
                      </li>
                      <li class="room-doc-share-file-item add link" @click="onClickAddLink">
                        <div class="room-doc-share-file">
                          <p class="room-doc-share-add-label">{{ $t("doc.share.add.link") }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
              </div>
            </perfect-scrollbar>
          </div>
          <div class="room-doc-share-list-container page">
            <div class="room-doc-share-start-header">
              <div class="room-doc-share-start-header-title-wrapper">
                <button class="room-doc-share-start-header-title back" @click="onToggleShowDocPage">{{ $t("doc.share.list") }}</button>
              </div>
            </div>
            <perfect-scrollbar class="min-h-0 flex-1"
                               ref="docListDetailScrollbar"
            >
              <div class="room-doc-share-start-body">
                <div class="room-doc-share-file-list-wrapper">
                  <RoomDocListDetail v-if="isShowDocPage" />
                </div>
              </div>
            </perfect-scrollbar>
          </div>
        </div>
        <GrmSlideToggleBtn direction="left"
                           class="absolute transform transition-none"
                           v-model="isOpenDocFileList"
                           v-tooltip.right="isOpenDocFileList ? $t('doc.share.close') : $t('doc.share.open')"
                           :class="[ isOpenDocFileList ? 'translate-x-1/2' : 'translate-x-full' ]"
                           @click="onToggleDocFileList"
        />
      </div>
      <div class="room-doc-share-center">
        <RoomDocView ref="csCanvas" roomGroupId="default" />
        <RoomDocPaging
          v-if="getCurrentRoomDocFile && getCurrentRoomDocFile.pages && getCurrentRoomDocFile.pages.length > 1"
          class="absolute top-2"
          @paging="() => this.isShowDocPage = true"
        />
        <RoomDocZoom v-if="!me.roomUserRole.draw"
                     class="absolute top-2 right-2"
        />
      </div>
      <div v-if="me.roomUserRole.draw"
           class="room-doc-share-end"
      >
        <RoomDocPalette ref="palette" />
      </div>
      <ProgressList />
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

import RoomDocList from "@/components/Room/Doc/List"
import RoomDocListDetail from "@/components/Room/Doc/ListDetail"
import RoomDocView from "@/components/Room/Doc/View"
import RoomDocPalette from "@/components/Room/Doc/Palette"
import URLShareLayer from "@/components/Room/URLShare/URLShareLayer.vue"
import ProgressList from '@/components/Room/Doc/ProgressList'
import GrmSlideToggleBtn from "@/components/Common/button/GrmSlideToggleBtn";
import RoomDocPaging from "@/components/Room/Doc/Paging";
import RoomDocZoom from "@/components/Room/Doc/Zoom";
import {clone} from "lodash/lang";

export default {
  name: 'RoomDocShare',
  components: {
    RoomDocZoom,
    RoomDocPaging,
    GrmSlideToggleBtn,
    RoomDocList,
    RoomDocListDetail,
    RoomDocView,
    RoomDocPalette,
    ProgressList
  },
  data() {
    return {
      isShowDocPage: false
    }
  },
  created() {
    this._Events = clone(_Events);
    this.$roomApi.addEventListeners(this._Events, this);

    this.viewDocPage();
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
  watch: {
    isShowDocPage: function(isShowDocPage) {
      if (isShowDocPage) {
        this.viewDocPage();
      }
    }
  },
  methods: {
    ...mapActions('doc', [
      'changeRoomDocPage',
      'uploadRoomDocFile',
      'removeRoomDocFile',
      'requestPresignedUrlForRoomDocFile',
    ]),
    ...mapMutations('doc', [
      'TOGGLE_IS_OPEN_DOC_FILE_LIST'
    ]),
    viewDocPage() {
      if (!this.getCurrentRoomDocFile || !this.getCurrentRoomDocFile.pages?.length || this.getCurrentRoomDocFile.pages?.length === 0) {
        return;
      }

      if (!this.isShowDocPage) {
        this.onToggleShowDocPage();
      }

      this.$nextTick(() => {
        this.selectedPageEl = document.querySelector('[data-grm-comp="ListDetail"] .room-doc-item.selected');
        if (this.selectedPageEl) {
          this.$refs.docListDetailScrollbar.$el.scrollTop = this.selectedPageEl.offsetTop - 12;
        }
      })
    },
    onToggleShowDocPage() {
      this.isShowDocPage = !this.isShowDocPage
    },
    setShowDocPage(flag) {
      this.isShowDocPage = flag
    },
    async handleClickAddDoc() {
      const files = await this.getFileChooser({
          multiple: true,
          accept: this.allowedFileExts,
          size: 3
      });
      if(files.length === 0) return;

      for(const file of files){
          if(!this.validExtension(file)) {
              this.$alert(this.$t('doc.notSupportFile'));
              continue;
          }
          let param = {file, filename: file.name, roomGroupId: 'default', setRoomDoc: false}
          await this.uploadRoomDocFile(param);
      }
    },
    validExtension (file){
      const fileNameArr = file.name.split('.')
      const extension = fileNameArr[fileNameArr.length - 1].toLowerCase()
      for(const allowExt of this.allowedFileExts.split(',')){
        if(allowExt.substring(1) !== extension){
          continue;
        } else{
          return true;
        }
      }
      return false;
    },
    onClickAddLink() {
      this.$modal(URLShareLayer)
    },
    onToggleDocFileList() {
      if (!this.isRoomMode('doc')) {
        return;
      }
      this.TOGGLE_IS_OPEN_DOC_FILE_LIST();
    },
  },
  computed: {
    ...mapGetters('room', [
      'roomMode',
      'isRoomMode'
    ]),
    ...mapGetters('user', [
      'me',
    ]),
    ...mapState('doc', [
      'uploadRoomDocFiles',
      'isOpenDocFileList'
    ]),
    ...mapGetters('doc', [
      'roomDoc',
      'allowedFileExts',
      'sharingRoomDoc',
      'sharingRoomGroupId',
      'getCurrentRoomDocFile',
    ]),
    ...mapGetters('url', [
      'urls',
    ]),
    ...mapGetters('roomGroup', [
      'roomGroupListNoDefault'
    ]),
  },
}

const _Events = {
  room_doc_changeRoomDocPage(e) {
    const { docPageId, userId } = e.data;
    if (this.me.userId === userId) {
      return;
    }

    this.isShowDocPage = !!docPageId;
  },
}
</script>

<style lang="scss" scoped>
.room-doc-share-component {
}

.room-doc-view-component {
  min-width: 0;
  flex: 1;
  height: 100%;
}

.room-doc-share {
  height: 100%;
  background-color: #f0f0f0;
  display: flex;
}

.room-doc-share-start {
  width: 0;
  border-right: 1px solid #c5c5c5;
  background-color: #f4f4f4;
  box-shadow: 4px 0 16px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
  z-index: 1;
  &.isOpen {
    width: 120px;
    .room-doc-share-list-wrapper {
      transform: translateX(0);
    }
  }
}

.room-doc-share-list-wrapper {
  width: 120px;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  overflow: hidden;
  transform: translateX(-100%);
  &.page {
    .room-doc-share-list-container {
      transform: translateX(-100%);
    }
  }
}

.room-doc-share-list-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
  inset: 0;
  transition: 0.3s ease-out;
  &.page {
    left: 100%;
  }
}

.room-doc-share-start-header {
  height: 30px;
  border-bottom: 1px solid #c5c5c5;
  background-color: #d2d2da;
  display: flex;
  justify-content: center;
  align-items: center;
}

.room-doc-share-start-header-title-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.room-doc-share-start-header-title {
  font-size: 12px;
  font-weight: 700;
  color: #666;
  line-height: 100%;
  transition: 0.1s ease-out;

  &.back {
    width: 100%;
    height: 100%;
    background: url('~@/assets/images/arrowLineThickLeft_gray.svg') no-repeat center left 6px / 12px auto;
    transition: 0.1s ease-out;

    &:hover {
      background: #6e6d7f url('~@/assets/images/arrowLineThickLeft_white.svg') no-repeat center left 6px / 12px auto;
      color: #fff;
    }
  }
}

.room-doc-share-start-body {
  flex: 1;
  min-height: 0;
  padding: 16px;
}

.room-doc-share-file-list-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px 0;
}

.room-doc-share-file-list {
  display: flex;
  flex-direction: column;
  gap: 16px 0;
}

.room-doc-share-file-item {
  width: 100%;
  position: relative;
  cursor: pointer;

  &.add {
    .room-doc-share-file {
      border: 1px dashed $mainColor;
      background-color: transparent;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &.file {
      .room-doc-share-file {
        &::before {
          content: '';
          width: 16px;
          height: 16px;
          background: url('~@/assets/images/plus_blue.svg') no-repeat center / 100% auto;
          display: block;
          transition: 0.1s ease-out;
        }
      }
    }

    &.link {
      .room-doc-share-file {
        &::before {
          content: '';
          width: 16px;
          height: 16px;
          background: url('~@/assets/images/link_blue.svg') no-repeat center / 100% auto;
          display: block;
          transition: 0.1s ease-out;
        }
      }
    }

    &:hover {
      .room-doc-share-file {
        background-color: $mainColor;
      }

      .room-doc-share-add-label {
        color: #fff;
      }

      &.file {
        .room-doc-share-file {
          &::before {
            background: url('~@/assets/images/plus_white.svg') no-repeat center / 100% auto;
          }
        }
      }

      &.link {
        .room-doc-share-file {
          &::before {
            background: url('~@/assets/images/link_white.svg') no-repeat center / 100% auto;
          }
        }
      }
    }
  }

  &.selected {
    .room-doc-share-file {
      border: 4px solid #09f !important;
    }

    .room-doc-share-file-title {
      color: #09f;
    }
  }

  &:hover {
    .room-doc-share-file {
      border: 1px solid #46cff3;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2)
    }
  }
}

.room-doc-share-add-label {
  margin-top: 6px;
  font-size: 12px;
  color: #666;
  transition: 0.1s ease-out;
}

.room-doc-share-add-input {
  display: none;
}

.room-doc-share-file {
  height: 56px;
  border: 1px solid #ccc;
  background-color: #fff;
  position: relative;
  pointer-events: none;
  transition: 0.1s ease-out;
}

.room-doc-share-file-select-button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.room-doc-share-file-title-wrapper {
  margin-top: 4px;
  text-align: center;
}

.room-doc-share-file-title {
  font-size: 10px;
  line-height: 1.4;
  transition: 0.1s ease-out;
  pointer-events: none;
}

.room-doc-share-file-button-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;

  .grm-menu-component {
    position: absolute;
    top: 100%;
    right: 0;
  }
}

.room-doc-share-file-button {
  width: 30px;
  height: 24px;
  background: url('~@/assets/images/more_gray.svg') no-repeat center / 16px auto;
  transition: 0.1s ease-out;

  &:hover {
    background: $mainColor url('~@/assets/images/more_white.svg') no-repeat center / 16px auto;
  }
}

.room-doc-share-center {
  min-width: 0;
  flex: 1;
  padding: 5px;
  display: flex;
  justify-content: center;
  position: relative;
}

.room-doc-share-end {
  width: 50px;
  border-left: 1px solid #c6c6c6;
  background-color: #f4f4f4;
}
</style>